import { createContext } from "react";

const AllSlidersContext = createContext();

export default AllSlidersContext;
